import classNames from 'classnames';
import { isNumber } from 'common/utils';
import Icon from 'components/common/Icon';
import { AnswerType } from 'service/course';
import styles from './AnswerItemView.module.scss';
interface AnswerItemViewProps {
  answerItem: AnswerType;
  onChooseAnswer?: (answerId: number) => void;
  type: 'normal' | 'selected' | 'wrong' | 'correct';
  answerIndex?: number;
}
const AnswerItemView = ({
  type,
  answerItem,
  onChooseAnswer,
  answerIndex,
}: AnswerItemViewProps) => {
  return (
    <div
      className={classNames(styles.answerItem, {
        [styles.isSelected]: type === 'selected',
        [styles.isCorrect]: type === 'correct',
        [styles.isWrong]: type === 'wrong',
      })}
      onClick={() => onChooseAnswer && onChooseAnswer(answerItem.id)}
    >
      <div className={styles.answerText}>
        {isNumber(answerIndex) && `${answerIndex + 1}. `}
        {answerItem.detail}
      </div>
      {type === 'selected' && (
        <div className={styles.icon}>
          <Icon name="checked-white" width={25} height={25} />
        </div>
      )}
      {type === 'correct' && (
        <div className={styles.icon}>
          <Icon name="done" width={18} height={18} />
        </div>
      )}
      {type === 'wrong' && (
        <div className={styles.icon}>
          <Icon name="wrong" width={20} height={20} />
        </div>
      )}
    </div>
  );
};

export default AnswerItemView;
